import { components } from "react-select";

import {
    GET_SENTRY_PROJECTS,
    GET_SENTRY_PROJECTS_FAILURE,
    GET_SENTRY_PROJECTS_SUCCESS
} from './actionTypes';

const INIT_STATE = {
    projects: [],
    error: null,
};


const Sentry = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SENTRY_PROJECTS:
            return {
                ...state,
            };
        case GET_SENTRY_PROJECTS_SUCCESS:
            return {
                ...state,
                projects: action.payload,
            };
        case GET_SENTRY_PROJECTS_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        default:
            return state;
    }
}

export default Sentry;